import React, { createContext, useContext, useLayoutEffect, useMemo, useState } from 'react';

import { useJiraContext } from 'src/services/jira';
import { useSession } from 'src/services/session';

import integration from 'src/lib/api/integration';

let currentAccountsMapping = null;
const Context = createContext(currentAccountsMapping);

let setAccountsMappingValue = () => {
  console.error('AccountsMapping provider is not installed');
};

export const Provider = ({ children }) => {
  const { context: { clientKey } = {} } = useJiraContext();
  const { loggedIn, environment } = useSession();
  const [hasConsumers, setHasConsumers] = useState(false);
  const [value, setValue] = useState([undefined, true, null]);
  currentAccountsMapping = value[0];

  useLayoutEffect(() => {
    if (!loggedIn || !hasConsumers) {
      setValue([null, false, null]);
    } else {
      setValue([undefined, true, null]);
      if (clientKey) {
        integration.getAccountMapping(environment.accountBaseUrl, clientKey)
          .then(value => setValue([value, false, null]))
          .catch(error => setValue([null, false, error]));
      }
    }
  }, [clientKey, loggedIn, environment, hasConsumers]);

  setAccountsMappingValue = (value) => setValue([value, false, null]);
  const contextValue = useMemo(() => [value, setHasConsumers], [value, setHasConsumers]);

  return (
    <Context.Provider value={contextValue}>
      {children}
    </Context.Provider>
  );
};

export const useAccountsMapping = () => {
  const [value, setHasConsumers] = useContext(Context);

  useLayoutEffect(() => {
    setHasConsumers(true);
  }, [setHasConsumers]);

  return value;
};

export const updateAccountsMapping = async (body) => {
  const res = await integration.updateAccountsMapping(body);
  setAccountsMappingValue(res);
  return res;
};

export const createAccountsMapping = async (creatorUserMapping) => {
  const res = await integration.createAccountsMapping(creatorUserMapping);
  setAccountsMappingValue(res);
  return res;
};

